import { YouTube } from './YouTube'
import { SoundCloud } from './SoundCloud'
import { Vimeo } from './Vimeo'
import { Facebook } from './Facebook'
import { Streamable } from './Streamable'
import { FaceMask } from './FaceMask'
import { Wistia } from './Wistia'
import { Twitch } from './Twitch'
import { DailyMotion } from './DailyMotion'
import { UstreamLive } from './UstreamLive'
import { UstreamVideo } from './UstreamVideo'
import { Iframe } from './Iframe'
import { Mixcloud } from './Mixcloud'
import { FilePlayer } from './FilePlayer'
import { VAST } from './VAST'

export default [
  YouTube,
  SoundCloud,
  Vimeo,
  Facebook,
  Streamable,
  FaceMask,
  Wistia,
  Twitch,
  DailyMotion,
  Mixcloud,
  UstreamLive,
  UstreamVideo,
  VAST,
  FilePlayer,
  Iframe
]



// WEBPACK FOOTER //
// ./src/players/index.js